import type { Education } from "../Types/Education";

export const educations: Education[] = [
  {
    title: {
      en: "MSc: Computer Science and Engineering - Software Engineering",
      da: "Kandidat: Datalogi og Software Engineering"
    },
    place: {
      en: "Technical University of Denmark",
      da: "Danmarks Tekniske Universitet"
    },
    start: "2020",
    end: "2023"
  },
  {
    title: {
      en: "BSc: Computer Science and Philosophy of Science",
      da: "Bachelor: Datalogi og Filosofi"
    },
    place: {
      en: "Roskilde University",
      da: "Roskilde Universitet"
    },
    start: "2017",
    end: "2020"
  }
];
